import React, { Component } from "react"
import { withRouter, Redirect } from "react-router-dom"

class Logout extends Component {
  componentWillMount() {
    localStorage.setItem("token", "")
  }
  render() {
    return <Redirect to="/login" />
  }
}
export default withRouter(Logout)



// WEBPACK FOOTER //
// ./src/views/auth/Logout.js